import { Button, CheckBox, Form } from "devextreme-react";
import { GroupItem, RequiredRule, SimpleItem } from "devextreme-react/form";
import moment from "moment";
import { forwardRef, useState } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../../redux/localization";
import { renderInformationItem } from "../../productRequestPage/detail";
import { ApproveProductComment, ProductComment, User } from "./type";

const ProductCommentDetail = forwardRef<any, { data: ProductComment, user?: User, approveData: ApproveProductComment }>(
  ({ data, user, approveData }, ref
  ) => {
    const localize = useSelector(getLocalized);
    const [value, setValue] = useState(false)
    const getUserInfo = async () => {
      window.open(`/#/account-details/${user?.AccountId}`)
    }
    const getSupplierInfo = () => {
      window.open(`/#/account-details/${data.SupplierAccount.Id}`)
    }
    return (
      <form>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
        </div>
        <Form
          ref={ref}
          key={data.Id}
          labelLocation="left"
          formData={data}
          showColonAfterLabel={true}
        >
          <GroupItem colCount={2}>
            <SimpleItem
              dataField="UserName"
              label={{
                text: localize.getString("username")
              }}
              render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem>
              <Button icon="arrowright" onClick={() => {
                getUserInfo()
              }}></Button>
            </SimpleItem>
          </GroupItem>
          <GroupItem colCount={2}>
            <SimpleItem
              dataField="ProductCardName"
              label={{
                text: localize.getString("productCardName")
              }}
              render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem>
              <Button icon="arrowright" onClick={() => {
                window.open(`/#/product-details/${data.ProductCardId}`)
              }}></Button>
            </SimpleItem>
          </GroupItem>
          <GroupItem>
            <SimpleItem
              dataField="Message"
              label={{
                text: localize.getString("message")
              }}
              render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
              dataField="Skore"
              label={{
                text: localize.getString("score")
              }}
              render={renderInformationItem}
            >
            </SimpleItem>
          </GroupItem>
          <GroupItem>
            <Form
              ref={ref}
              key="Id"
              labelLocation="left"
              formData={approveData}
              showColonAfterLabel={true}
            >
              <GroupItem colCount={2}>
                <GroupItem>
                  <SimpleItem
                    dataField="approval"
                    label={{
                      text: localize.getString("approve"),
                    }}

                    editorType={"dxCheckBox"}
                    render={(item: any) => {
                      return <CheckBox
                        value={approveData.approval}
                        onValueChanged={(e: any) => {
                          setValue(e.value)
                          approveData.approval = e.value
                        }}
                      ></CheckBox>;
                    }}
                  />
                  {/* <SimpleItem
                    dataField="approval"
                    label={{
                      text: localize.getString("approve"),
                    }}

                    editorType={"dxCheckBox"}
                    render={(item: any) => {
                      return <CheckBox
                        value={newData.current.approval}
                        onValueChanged={(e: any) => {
                          setValue(e.value)
                          newData.current.approval = e.value
                        }}
                      ></CheckBox>;
                    }}
                  /> */}
                  <SimpleItem
                    dataField={"message"}
                    editorType={"dxTextBox"}
                    label={{
                      text: localize.getString("message")
                    }}
                  >
                    {value === false ? <RequiredRule message={localize.getString("required")} /> : ""}
                  </SimpleItem>
                </GroupItem>
              </GroupItem>
            </Form>
          </GroupItem>
          <GroupItem
            caption={localize.getString("contractInformation")}
          >
            <SimpleItem
              dataField={"Code"}
              label={{
                text: localize.getString("code")
              }}
              render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
              dataField={"StartDate"}
              label={{
                text: localize.getString("startDate")
              }}
              editorType="dxDateBox"
              editorOptions={{
                dateSerializationFormat: "yyyy-MM-dd"
              }}
              render={
                (item: any) => {
                  if (item.editorOptions.value !== null) {
                    return <span>{moment.utc(item.editorOptions.value).format("l")}</span>;
                  } else {
                    return <span>-</span>;
                  }
                }
              }
            >
            </SimpleItem>
            <SimpleItem
              dataField={"EndDate"}
              editorType="dxDateBox"
              editorOptions={{
                dateSerializationFormat: "yyyy-MM-dd"
              }}
              label={{
                text: localize.getString("endDate")
              }}
              render={
                (item: any) => {
                  if (item.editorOptions.value !== null) {
                    return <span>{moment.utc(item.editorOptions.value).format("l")}</span>;
                  } else {
                    return <span>-</span>;
                  }
                }
              }
            >
            </SimpleItem>
          </GroupItem>
          <GroupItem caption={localize.getString("supplier")}>
            <GroupItem colCount={2}>
              <SimpleItem
                dataField="SupplierAccount.AccountName"
                label={{
                  text: localize.getString("username")
                }}
                render={renderInformationItem}
              >
              </SimpleItem>
              <SimpleItem>
                <Button icon="arrowright" onClick={() => {
                  getSupplierInfo()
                }}></Button>
              </SimpleItem>
            </GroupItem>
            <SimpleItem
              dataField={"SupplierAccount.Email"}
              label={{
                text: localize.getString("email")
              }}
              render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
              dataField={"SupplierAccount.Phone"}
              label={{
                text: localize.getString("phone")
              }}
              render={renderInformationItem}
            >
            </SimpleItem>
          </GroupItem>
          <GroupItem caption={localize.getString("customer")}>
            <SimpleItem
              dataField={"CustomerUser.Name"}
              label={{
                text: localize.getString("name")
              }}
              render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
              dataField={"CustomerUser.Surname"}
              label={{
                text: localize.getString("surname")
              }}
              render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
              dataField={"CustomerUser.Email"}
              label={{
                text: localize.getString("email")
              }}
              render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
              dataField={"CustomerUser.Phone"}
              label={{
                text: localize.getString("phone")
              }}
              render={renderInformationItem}
            >
            </SimpleItem>
          </GroupItem>
        </Form>
      </form>
    )
  }
)

export default ProductCommentDetail;
